import React, { useEffect, useState } from "react";
import { Card, Stack, Button, Container, Typography, Grid, Box } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";
import GoTable from "../../common/GoTable/GoTable";
import { OTHER_FEES_TABLE_HEADS } from "../../configs/TableHeaderConstants";
import EntityConstants from "../../configs/EntityConstants";
import { get, gen_link, post } from "../../services/FetchHelper";
import SpinService from "../../services/SpinService";
import { otherFeesConfig } from "./Reports.utils";
import { Form, Formik } from "formik";
import GoForm from "../../components/Inputs/GoForm";
import { styled } from "@mui/material/styles";

const StyledRoot = styled("div")(({ theme }) => ({
    width: "100%",
    display: "block",
    padding: theme.spacing(2, 2, 2, 2),
    paddingBottom: '10px'
}));

const OtherFeesReport = () => {
    const spinService = SpinService();
    const [formFields, setFormFields] = useState(otherFeesConfig.formFields);
    const [data, setData] = useState([]);
    const [lastValues, setLastValues] = useState({});

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name ? { ...field, options } : field
            )
        );
    };

    const handleSubmit = async (values) => {
        spinService.on();
        setLastValues(values);
        const response = await post(EntityConstants.OTHER_FEES_REPORT, values);
        const result = await response.json();
        setData(result);
        spinService.off();
    };

    const downloadHandle = () => {
        const link = document.createElement('a');
        link.href = gen_link(EntityConstants.OTHER_FEES_REPORT_DOWNLOAD, `filter=${encodeURIComponent(JSON.stringify(lastValues))}`);
        link.target = '_blank';
        link.click();
    };

    useEffect(() => {
        const fetchDeps = async () => {
            const schoolsResp = await get(EntityConstants.SCHOOLSBYCOMPANIES);
            const schools = await schoolsResp.json();
            attachOptions("school_id", schools);
        };
        fetchDeps();
    }, []);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h4" gutterBottom>
                        OTHER FEES REPORT
                    </Typography>
                </Stack>
                <Card>
                    <StyledRoot>
                        <Formik
                            enableReinitialize
                            initialValues={otherFeesConfig.state}
                            validationSchema={otherFeesConfig.schema}
                            onSubmit={(values) => handleSubmit(values)}
                        >
                            {({ values, touched, errors, handleChange, handleSubmit }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Grid container justifyContent="space-between" alignItems="center" rowSpacing={1} columnSpacing={1}>
                                        {formFields.map((formField, index) => (
                                            <Grid key={index} item xs={12} sm={12} md={3} lg={3}>
                                                <GoForm
                                                    config={formField}
                                                    values={values}
                                                    touched={touched}
                                                    errors={errors}
                                                    handleChange={handleChange}
                                                />
                                            </Grid>
                                        ))}
                                        <Grid item xs={12} sm={12} md={3} lg={3} style={{ display: "flex", justifyContent: "end" }}>
                                            <Box sx={{ p: 1 }}>
                                                <Button
                                                    variant="contained"
                                                    startIcon={<Iconify icon="eva:search-fill" />}
                                                    type="submit"
                                                >
                                                    Filter
                                                </Button>
                                            </Box>
                                            <Box sx={{ p: 1 }}>
                                                <Button
                                                    disabled={data.length === 0}
                                                    variant="contained"
                                                    startIcon={<Iconify icon="typcn:download" />}
                                                    onClick={downloadHandle}
                                                >
                                                    Download
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                    </StyledRoot>
                </Card>
                <Card>
                    <GoTable
                        tableHeads={OTHER_FEES_TABLE_HEADS}
                        tableDatas={data}
                        totalCount={0}
                        search={false}
                        pagination={false}
                    />
                </Card>
            </Container>
        </React.Fragment>
    );
};

export default OtherFeesReport;
